import React from 'react'
import { Badge, Card, Tabs } from 'hljd'
import { inject, observer } from 'mobx-react'
import Style from './style.module.less'
//直播设置组件
import LiveContent from './liveContent'
//直播连麦组件
import LiveLinkMicrophone from './liveLinkMicrophone'
//直播抽奖
import LiveLottery from './liveLottery'

const { TabPane } = Tabs

export default inject('store')(
  observer(({ store: { liveLinkMicrophoneStore } }) => {
    // 直播设置tabs
    const LiveSet = [
      {
        key: '1',
        title: '直播内容',
        content: <LiveContent />
      },
      {
        key: '2',
        title: (
          <Badge
            title="待连麦用户数"
            count={liveLinkMicrophoneStore.isLinkMicrophoneUsers.length}
            overflowCount={500}
            offset={[10, -5]}
          >
            <span style={{ fontSize: '16px' }}>直播连麦</span>
          </Badge>
        ),
        content: <LiveLinkMicrophone />
      },
      {
        key: '3',
        title: '直播抽奖',
        content: <LiveLottery />
      }
    ]
    return (
      <div className={Style['live-content-wrap']}>
        {/* 公告 */}
        <Card title="直播设置要求" bordered={0} className={Style['live-set']}>
          <div className={Style['notice']}>
            <p>
              <span> ● </span>不可含有任何蕴含国别歧视、民族歧视、种族歧视、宗教歧视、文化歧视、行政地域歧视及暴力等其他有悖于公俗良允的内容；
            </p>
            <p>
              <span> ● </span>不可出现商家微信、手机号相关的信息，图片不可添加水印、logo；
            </p>
            <p>
              <span> ● </span>如有违反将禁止使用营销工具。
            </p>
          </div>
        </Card>

        {/* 直播内容、直播连麦、直播抽奖 */}
        <Tabs
          animated={false}
          tabBarStyle={{ padding: '0 20px' }}
          className={Style['tabs-wrap']}
        >
          {LiveSet.map(({ key, title, content }) => (
            <TabPane tab={title} key={key} forceRender={false}>
              {content}
            </TabPane>
          ))}
        </Tabs>
      </div>
    )
  })
)
